import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CalcularPrecoService {
  calcularPreco(formValues: any, campoParaCalculo: string | null): any {
    const custoCompra = formValues.custoCompra || 0;
    const totalEncargos = (
      (formValues.impostoSVenda || 0) +
      (formValues.acrescimoFinanceiro || 0) +
      (formValues.despesaOperacional || 0) +
      (formValues.outros || 0) +
      (formValues.comissao || 0)
    );
    const totalCusto = 0;

    let precoVend = 0;
    let margSVend = 0;
    let margSCust = 0;
    let lucrSVend = 0;
    let lucrSCust = 0;
    let indiceCalc = 0;

    console.log('formValues', formValues);
    console.log('campoParaCalculo', campoParaCalculo);  
    

    switch (campoParaCalculo) {
      case 'PRECO_VENDA_INPUT':
        precoVend = formValues.precoVendaInput || 0;
        lucrSVend = precoVend - totalCusto;
        margSVend = precoVend > 0 ? (lucrSVend / precoVend) * 100 : 0;
        margSCust = custoCompra > 0 ? (lucrSVend / custoCompra) * 100 : 0;
        lucrSCust = lucrSVend;
        indiceCalc = margSCust / 100;
        break;

      case 'LUCROS_S_PRECO_VENDA_INPUT':
        margSVend = formValues.lucrosSPreInput || 0;
        precoVend = totalCusto / (1 - margSVend / 100);
        lucrSVend = precoVend - totalCusto;
        margSCust = custoCompra > 0 ? (lucrSVend / custoCompra) * 100 : 0;
        lucrSCust = lucrSVend;
        indiceCalc = margSCust / 100;
        break;

      case 'LUCRO_S_PRECO_CUSTO_INPUT':
        margSCust = formValues.lucrosSPrecoCustoInput || 0;
        lucrSCust = custoCompra * (margSCust / 100);
        precoVend = totalCusto + lucrSCust;
        lucrSVend = lucrSCust;
        margSVend = precoVend > 0 ? (lucrSVend / precoVend) * 100 : 0;
        indiceCalc = margSCust / 100;
        break;

      case 'VALOR_PRECO_VENDA_INPUT':
        lucrSVend = formValues.valorPrecoVendaInput || 0;
        precoVend = totalCusto + lucrSVend;
        margSVend = precoVend > 0 ? (lucrSVend / precoVend) * 100 : 0;
        margSCust = custoCompra > 0 ? (lucrSVend / custoCompra) * 100 : 0;
        lucrSCust = lucrSVend;
        indiceCalc = margSCust / 100;
        break;

      case 'VALOR_PRECO_CUSTO_INPUT':
        lucrSCust = formValues.valorPrecoCustoInput || 0;
        precoVend = totalCusto + lucrSCust;
        lucrSVend = lucrSCust;
        margSVend = precoVend > 0 ? (lucrSVend / precoVend) * 100 : 0;
        margSCust = custoCompra > 0 ? (lucrSCust / custoCompra) * 100 : 0;
        indiceCalc = margSCust / 100;
        break;

      case 'INDICE_INPUT':
        indiceCalc = formValues.indiceInput || 0;
        margSCust = indiceCalc * 100;
        lucrSCust = custoCompra * indiceCalc;
        precoVend = totalCusto + lucrSCust;
        lucrSVend = lucrSCust;
        margSVend = precoVend > 0 ? (lucrSVend / precoVend) * 100 : 0;
        break;

      default:
        precoVend = totalCusto; // Caso padrão sem cálculo adicional
    }

    return {
      precoVend,
      margSVend,
      margSCust,
      lucrSVend,
      lucrSCust,
      totCusVP: totalCusto,
      totCusVV: totalCusto,
      totEncV: totalEncargos,
      indiceCalc
    };
  }
}